import { Realty, services } from '@ambita/ambita-components-core';
import { ApiFloor } from '../../../typings/CadastreReport';

const util = services.util;
const filters = services.filters;

function transformFloors(floorsData: Realty.ApiResponse) {
  if (floorsData.items && floorsData.items.length > 0) {
    const floors: ApiFloor[] = floorsData.items;
    const retObject: any = {
      floors: []
    };

    floors.forEach((floor: ApiFloor) => {
      const tmpObj: any = util.pick(floor, [
        'numberOfDwellingUnits',
        'totalUsableArea',
        'totalAreaOfPrimarySpace',
        'totalAlternateArea',
        'totalUsableArea',
        'totalAreaHousing',
        'totalFloorSpace',
        'totalArea'
      ]);
      if (floor.ident.floorNumber) {
        tmpObj.floorNumber = floor.ident.floorNumber;
      }
      if (floor.ident.floorLevelCode.code && floor.ident.floorNumber) {
        tmpObj.floorIdent =
          `${floor.ident.floorLevelCode.code}${filters.padLeft(floor.ident.floorNumber + '', 2, '0')}`;
      }
      retObject.floors.push(tmpObj);
    });
    return retObject;
  }
}

export default transformFloors;
